module.exports = __webpack_public_path__ + "static/img/guaduan2.7fe8e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/guaduan2.png
// module id = vsUr
// module chunks = 24